module.exports = __webpack_public_path__ + "media/images/ei-logo-3b94d579d327b2456fe330bc84b2ac4e.svg";